function init() {
    // There are media/text blocks where the text is very long relative to the image.
    // We will implement a sticky effect to improve user experience.
    
    // Configurable variables
    var MIN_WIDTH = 600;
    var STICKY_OFFSET = 50; // px

    function setupMediaTextSticky() {
        // Remove any previous event handlers or inline styles
        jQuery('.wp-block-media-text__media').each(function() {
            jQuery(this).css({ position: '', top: '', left: '', right: '', width: '', zIndex: '' });
        });
        jQuery('.wp-block-media-text').css('position', '');
        jQuery(window).off('scroll.mediaTextSticky');

        if (window.innerWidth < MIN_WIDTH) {
            return;
        }

        jQuery('.wp-block-media-text').each(function() {
            var $block = jQuery(this);
            var $media = $block.find('.wp-block-media-text__media');
            var $content = $block.find('.wp-block-media-text__content');

            if ($media.length === 0 || $content.length === 0) return;

            var mediaHeight = $media.outerHeight();
            var contentHeight = $content.outerHeight();

            if (contentHeight < 1.5 * mediaHeight) {
                // No sticky needed
                return;
            }

            // Ensure parent is relative for absolute positioning
            $block.css('position', 'relative');

            // Store the original width as a data attribute
            $media.data('original-width', $media.outerWidth());

            // For vertically centered, store the centering offset
            if ($block.hasClass('is-vertically-aligned-center')) {
                var blockOffset = $block.offset().top;
                var mediaOffset = $media.offset().top;
                var centeringOffset = mediaOffset - blockOffset;
                $media.data('centering-offset', centeringOffset);
            } else {
                $media.removeData('centering-offset');
            }
        });

        // Scroll handler for all blocks
        jQuery(window).on('scroll.mediaTextSticky', function() {
            jQuery('.wp-block-media-text').each(function() {
                var $block = jQuery(this);
                var $media = $block.find('.wp-block-media-text__media');
                var $content = $block.find('.wp-block-media-text__content');

                if ($media.length === 0 || $content.length === 0) return;

                var mediaHeight = $media.outerHeight();
                var contentHeight = $content.outerHeight();

                if (contentHeight < 1.5 * mediaHeight) return;

                var blockOffset = $block.offset().top;
                var blockLeft = $media.offset().left;
                var originalMediaWidth = $media.data('original-width');
                var isRightAligned = $block.hasClass('has-media-on-the-right');
                var isVerticallyCentered = $block.hasClass('is-vertically-aligned-center');
                var scrollTop = jQuery(window).scrollTop();

                // For vertically centered, use the centering offset for sticky start
                var centeringOffset = isVerticallyCentered ? ($media.data('centering-offset') || 0) : 0;
                var startStick = blockOffset + centeringOffset - STICKY_OFFSET;
                var stopStick = blockOffset + contentHeight - mediaHeight - STICKY_OFFSET;

                if (scrollTop >= startStick && scrollTop < stopStick) {
                    $media.css({
                        position: 'fixed',
                        top: STICKY_OFFSET + 'px',
                        left: blockLeft + 'px',
                        right: '',
                        width: originalMediaWidth + 'px',
                        zIndex: 10
                    });
                } else if (scrollTop >= stopStick) {
                    if (isRightAligned) {
                        $media.css({
                            position: 'absolute',
                            top: (contentHeight - mediaHeight) + 'px',
                            left: '',
                            right: '0',
                            width: originalMediaWidth + 'px',
                            zIndex: 10
                        });
                    } else {
                        $media.css({
                            position: 'absolute',
                            top: (contentHeight - mediaHeight) + 'px',
                            left: '0',
                            right: '',
                            width: originalMediaWidth + 'px',
                            zIndex: 10
                        });
                    }
                } else {
                    $media.css({
                        position: '',
                        top: '',
                        left: '',
                        right: '',
                        width: '',
                        zIndex: ''
                    });
                }
            });
        });
    }

    // Run on load and resize
    jQuery(function() {
        setupMediaTextSticky();
        jQuery(window).on('resize.mediaTextSticky', function() {
            setupMediaTextSticky();
        });
    });
}

export { init as default }